module.exports = __webpack_public_path__ + "media/icons/ubezpieczenia@3x-60db46eb.svg";